import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { Spinner } from '@treams/treams-ui';

const LoadingCard = styled(Flex)`
	border: 0;
	border-radius: 5px;
	align-items: center;
	justify-content: center;
	padding: 32px 0;
`;

export function DashboardEngagementLoading() {
	return (
		<LoadingCard>
			<Spinner />
		</LoadingCard>
	);
}
